import React from "react";
import { Route, Routes } from "react-router-dom";
import { MenulogDetails } from "./components/MenulogDetails";
import { ProtectedRoute } from "../../shared";
import { MenulogList } from "./components";

export const Menulog = () => {
    return (
        <>
            <Routes>
                <Route path="/" element={<MenulogList />} />
                <Route element={<ProtectedRoute allowedRoute={["menulog-view"]} />}>
                    <Route path="/details/:id" element={<MenulogDetails />} />
                </Route>
            </Routes>
        </>
    );
};
